export const serviceContent = [
  {
    heroTitle: "Time For Your Yearly Boiler Service?",
    heroImg: "",
  },
  {
    introTitle: "We Service Boilers Throughout West Yorkshire",
    introText: `If you’re in Leeds or the surounding area give Aquaheat a call. Our expert heating engineers carry out yearly services for both homeowners and businesses. Book your service today!`,
  },
  {
    contLeftTitle: "We're Approved Serivce Partners",
    contLeftText: `AquaHeat is trusted by the biggest boiler brands on the market. All our engineers are trained to meet the highest industry standards to be manufacturer approved. `,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643103356/AquaHeat/new%20images/Screenshot_2022-01-25_at_09.28.07_dmx7tf.webp`,
  },
  {
    contRightTitle: "We Service All Types of Boilers",
    contRightText: `We can offer boiler servicing on all makes of combi, conventional, BBU and system boilers. If you a boiler service, don't hesitate to contact the team at Aquaheat`,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,w_580/v1643102547/AquaHeat/new%20images/plumb_btfmwv.webp`,
  },
  {
    callToActionTitle: "For Servicing Call On 0113 467 0278",
    callToActionSubTitle: "Servicing Over 8000 homes and businesses",
    callToActionText: `We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.`,
  },
];
